import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { useYoutubeStatsEnabled } from '@app/modules/audit/hooks/useYoutubeStatsEnabled';
import { isTranscriptionEnabled } from '@app/modules/fragments/helpers/is-transcription-enabled';
import { useContext } from 'react';
import { AuditFocusMarkers } from '../../components/audit/focus-markers/AuditFocusMarkers';
import { YoutubeStatsWaveformGraph } from '../../components/audit/youtube-stats/YoutubeWaveformGraph';
import { Focus } from '../../components/focus/Focus';
import { DiarizationContext } from '../../diarization/DiarizationContext';
import { FocusEditorChunks } from '../../fragment-editor/components/focus/FocusEditorChunks';
import { useStreamSettingsStore } from '../../stores/stream-screen-settings.store';
import { StreamMode } from '../../types';
import { HoveredDiarization } from '../video/diarization/HoveredDiarization';

/**
 * Audio-specific focus component that renders focus markers, editor chunks,
 * diarization, and YouTube stats within the Focus component.
 */
export function AudioFocus() {
  const { rawData } = useContext(DiarizationContext);

  const station = useActiveStation();
  const mode = useStreamSettingsStore((state) => state.mode);
  const editorModeEnabled = mode === StreamMode.EDITOR;
  const transcriptionEnabled = isTranscriptionEnabled(station);
  const isYtstatsActive = useYoutubeStatsEnabled(station);
  const settingsAudit = useStreamSettingsStore((state) => state.audit);

  return (
    <Focus>
      <AuditFocusMarkers />
      {editorModeEnabled && <FocusEditorChunks />}
      {transcriptionEnabled ? <HoveredDiarization diarization={rawData} /> : null}
      {settingsAudit.ytstats && isYtstatsActive ? <YoutubeStatsWaveformGraph /> : null}
    </Focus>
  );
}
